const trackEvent = (eventName, properties) => {
	const eventProperties = {
		ctaClick: {
			linkTrackEvents: 'event13',
			linkTrackVars: 'eVar16,eVar58,events',
		},
		downloadCsv: {
			linkTrackEvents: 'event8',
			linkTrackVars: 'eVar16,eVar23,events,eVar58',
		},
		downloadPdf: {
			linkTrackEvents: 'event8',
			linkTrackVars: 'eVar16,eVar23,events,eVar58',
		},
		createCartWfc: {
			linkTrackEvents: 'scAdd',
			linkTrackVars: 'eVar16,eVar53,eVar59,eVar97,eVar101,prop53,channel,events,eVar58',
		},
		cartUpdateWfc: {
			linkTrackEvents: 'scAdd',
			linkTrackVars: 'eVar16,eVar53,eVar59,eVar97,eVar101,prop53,channel,events,eVar58',
		},
		showWorkflow: {
			linkTrackEvents: 'event5',
			linkTrackVars: 'eVar16,eVar100,events,eVar58',
		},
		showProducts: {
			linkTrackEvents: 'event5',
			linkTrackVars: 'eVar16,eVar100,events,eVar58',
		},
	};

	if (typeof s !== 'undefined' && s.tl && typeof s.tl === 'function') {
		if (!properties['pageName']) {
			properties.pageName = 'QIAGEN - Workflow Configurator';
		}
		properties.linkTrackEvents = eventProperties[eventName].linkTrackEvents;
		properties.linkTrackVars = eventProperties[eventName].linkTrackVars;
		properties.events = eventProperties[eventName].linkTrackEvents;
		for (const [key, value] of Object.entries(properties)) {
			s[key] = value;
		}
		try {
			s.tl(true, 'o', eventName, properties);
		} catch (error) {
			window.appInsights.trackException({exception: error});
		}
	}
};

const trackObject = (properties) => {
	if (typeof s !== 'undefined' && s.t && typeof s.t === 'function') {
		for (const [key, value] of Object.entries(properties)) {
			s[key] = value;
		}
		try {
			s.t(properties);
		} catch (error) {
			window.appInsights.trackException({exception: error});
		}
	}
};

const createObject = (pageName, country, isLoggedIn, userId) => ({
	pageName: pageName,
	channel: 'Shop | Workflow Configurator',
	eVar35: pageName,
	eVar16: pageName,
	eVar8: country,
	eVar21: isLoggedIn ? 'loggedin' : 'not loggedin',
	eVar22: isLoggedIn ? 'registered' : 'not registered',
	eVar30: userId,
	eVar50: document.referrer || window.parent.location,
	eVar53: window.location.href,
});

export {trackEvent, trackObject, createObject};
